import axios, { CancelTokenSource } from 'axios';
import { useContext, useRef } from 'react';
import useSWR from 'swr';
import {
  AXIOS_CANCEL_MSG, User,
} from '../api/models';
import { ConfiguratorContext } from '../context';


interface UserProps {
}

export const useUsers = (props?: UserProps) => {

  const cancelTokenSourceRef = useRef<CancelTokenSource>();
  const configurator = useContext(ConfiguratorContext);

  const fetcher = async ( props?:UserProps  ) : Promise<User[] | undefined> => {

    //const { quoteId, revision } = props;
    //if (!revision) return;

    if ( cancelTokenSourceRef.current ) {
      cancelTokenSourceRef.current.cancel( AXIOS_CANCEL_MSG );
    }
    const cancelSource = axios.CancelToken.source();
    cancelTokenSourceRef.current = cancelSource;

    try {
      const resp = await configurator.api.fetchUserList();
      cancelTokenSourceRef.current = undefined;

      return resp.data.sort((a,b) => a.name.localeCompare(b.name));
    }
    catch(e: any) {
      const id = e.response?.data?.message || e.message ;
      if ( id === AXIOS_CANCEL_MSG ) return;
      throw e;
    }
  };

  // Use SWR for data fetching
  return useSWR([
    'users',
        //props
  ],
      //([_k, p]) => fetcher(p),
    ([_k ]) => fetcher(),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval:1
    }
  );
};


export default useUsers;

